import { Types } from '@grandvisionhq/graphql';
import { getLocalizedString } from '@grandvisionhq/utils';

const getPrice = (serverPrice, locale)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    if (!serverPrice || !serverPrice.originalPrice) {
        return undefined;
    }
    const originalPrice = serverPrice.originalPrice.amount;
    const discountedPrice = (ref = serverPrice.discountedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.amount;
    const discountBadgeRaw = (ref2 = serverPrice.discountedPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.discountInformation) === null || ref3 === void 0 ? void 0 : ref3.name;
    const discountBadge = discountBadgeRaw && getLocalizedString(discountBadgeRaw, locale);
    const discountDescriptionRaw = (ref4 = serverPrice.discountedPrice) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discountInformation) === null || ref5 === void 0 ? void 0 : ref5.description;
    const discountDescription = discountDescriptionRaw && getLocalizedString(discountDescriptionRaw, locale);
    const currency = (ref6 = serverPrice.originalPrice) === null || ref6 === void 0 ? void 0 : ref6.currencyCode;
    const loyaltyPoints = serverPrice.loyaltyPoints;
    return {
        originalPrice,
        isCentAmount: false,
        discountedPrice,
        discountDescription,
        discountBadge,
        currency,
        loyaltyPoints
    };
};
const getPurchaseTypePrices = (serverPriceList, locale)=>{
    const singlePurchasePriceRaw = serverPriceList.find((price)=>price.priceType === Types.ProductPriceItemType.SINGLE_PURCHASE
    );
    const subscriptionPurchasePriceRaw = serverPriceList.find((price)=>price.priceType === Types.ProductPriceItemType.SUBSCRIPTION
    );
    return {
        'single-purchase': getPrice(singlePurchasePriceRaw, locale),
        'subscription-purchase': getPrice(subscriptionPurchasePriceRaw, locale)
    };
};

export { getPurchaseTypePrices };
//# sourceMappingURL=get-purchase-type-prices.js.map
